import React from 'react';
import SessionStore from 'stores/shared/session';
import { t, loadLocales } from 'services/translation';
import $ from 'jquery';
import _ from 'underscore';
import ModalActionCreator from 'action_creators/modal';
import GlobalError from 'views/plugins/global_error';
import PaymentError from 'views/plugins/global_error/PaymentError';
import { CheckoutError } from 'views/plugins/global_error/CheckoutError';
import SessionTimeoutError from 'views/plugins/global_error/SessionTimeoutError';
import { TimeSlotError } from 'views/plugins/global_error/TimeSlotError';
import { TimeSlotCapacityError } from 'views/plugins/global_error/TimeSlotCapacityError';
import * as Sentry from '@sentry/react';

const ourDomain = function (url) {
  const allowedDomains = [/0\.0\.0\.0/, /anyguide\.com/, /anyroad\.com/];

  // in case of path instead of domain
  // e.g. /api/hyper/duper/action
  if (url.match(/^\/[a-zA-Z0-9]/)) {
    return true;
  }
  return (
    _.find(allowedDomains, (matcher) => {
      return url.match(matcher) !== null;
    }) !== undefined
  );
};

const captureStatus = function (status) {
  return status >= 500 || _.includes([404, 410], status);
};

$(document).ajaxError((event, jqxhr, settings, thrownError) => {
  loadLocales(SessionStore.state.get('i18n'));

  Sentry.setTag('location', 'global_ajax_error');

  const sentryData = {
    type: settings.type,
    url: settings.url,
    data: settings.data,
    status: jqxhr.status,
    error: thrownError || jqxhr.statusText,
    response: jqxhr.responseText,
    responseJSON: jqxhr.responseJSON,
  };

  const captureWithScope = (message, level) => {
    Sentry.withScope((scope) => {
      for (const key in sentryData) {
        scope.setExtra(key, sentryData[key]);
      }
      Sentry.captureMessage(message, level);
    });
  };

  // Slots taken error message interception
  if (
    jqxhr.status === 400 &&
    jqxhr.responseJSON.code &&
    jqxhr.responseJSON.code === 'slots_taken'
  ) {
    captureWithScope('Slots Taken Error on Checkout', 'error');

    const title = `${t('OOPS')}.`;
    const message = `${t('THE_TIME_YOU_SELECTED_HAS_BEEN_SOLD_OUT')}.`;
    const secondaryMessage = `${t(
      'PLEASE_REFRESH_THE_PAGE_AND_TRY_AGAIN_WITH_A_DIFFERENT_TIME_OR_DATE'
    )}.`;

    ModalActionCreator.show({
      content: (
        <CheckoutError
          title={title}
          message={message}
          secondaryMessage={secondaryMessage}
        />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: true,
    });
  }

  // Card declined error message interception
  if (
    jqxhr.status === 400 &&
    jqxhr.responseJSON.error_type &&
    jqxhr.responseJSON.error_type === 'payment_error'
  ) {
    captureWithScope('Payment Error on Checkout', 'error');
    ModalActionCreator.show({
      content: (
        <PaymentError errorMessage={jqxhr.responseJSON.stripe_message} />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: true },
      showIcon: true,
    });
  }

  // Timeslot error message interception
  if (
    jqxhr.status === 409 &&
    jqxhr.responseJSON.error_type &&
    jqxhr.responseJSON.error_type === 'timeslot_error'
  ) {
    ModalActionCreator.show({
      content: (
        <TimeSlotError
          errorMessage="Sorry, the selected booking time isn't available anymore."
          errorPrompt="Please change your selection and try again."
        />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: false,
    });
  }

  // TimeslotCapacity error message interception
  if (
    jqxhr.status === 409 &&
    jqxhr.responseJSON.error_type &&
    jqxhr.responseJSON.error_type === 'timeslot_capacity_error'
  ) {
    ModalActionCreator.show({
      content: (
        <TimeSlotCapacityError errorPrompt={jqxhr.responseJSON.error_message} />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: false,
    });
  }

  if (ourDomain(settings.url) && captureStatus(jqxhr.status)) {
    captureWithScope('Global Error on Checkout', 'error');
    ModalActionCreator.show({
      content: <GlobalError statusCode={jqxhr.status} />,
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: false,
    });
  }

  // Remember to check this the session timeout time if this is causing issues.
  // Might some other auth issue as 401 can be any unauthorized access.
  if (jqxhr.status === 401) {
    captureWithScope('Timeout Error.', 'error');
    ModalActionCreator.show({
      content: <SessionTimeoutError />,
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: true,
    });
  }
});
